import React, { useState } from "react";
import "./UserAccessSection.scss";
import { Link } from "react-router-dom";

const UserAccessSection = () => {
  const [rows, setRows] = useState([
    {
      user_name: "Camille",
      role: "Super Admin",
      email: "camille@teleport.com",
      phone_number: "Active",
      last_login: "Active",
      action: <img src="/images/icons/pen.svg" alt="Edit" />,
      img: <img src="/images/icons/cross-circle.svg" alt="Delete" />,
      selected: false,
    },
    {
      user_name: "Claire",
      role: "Admin",
      email: "claire@teleport.com",
      phone_number: "Active",
      last_login: "Active",
      action: <img src="/images/icons/pen.svg" alt="Edit" />,
      img: <img src="/images/icons/cross-circle.svg" alt="Delete" />,
      selected: false,
    },
    {
      user_name: "Isabelle",
      role: "Manager",
      email: "isabelle@teleport.com",
      phone_number: "Active",
      last_login: "Active",
      status: "Draft",
      action: <img src="/images/icons/pen.svg" alt="Edit" />,
      img: <img src="/images/icons/cross-circle.svg" alt="Delete" />,
      selected: false,
    },
    {
      user_name: "Charlotte",
      role: "Manager",
      email: "charlotte@teleport.com",
      phone_number: "Active",
      last_login: "Active",
      action: <img src="/images/icons/pen.svg" alt="Edit" />,
      img: <img src="/images/icons/cross-circle.svg" alt="Delete" />,
      selected: false,
    },
  ]);

  // Is header checkbox checked?
  const allChecked = rows.every((row) => row.selected);

  // Toggle all rows
  const handleSelectAll = () => {
    const newValue = !allChecked;
    setRows(rows.map((row) => ({ ...row, selected: newValue })));
  };

  // Toggle single row
  const handleRowSelect = (index) => {
    const updated = [...rows];
    updated[index].selected = !updated[index].selected;
    setRows(updated);
  };

  return (
    <section className="userAccess-page-section">
      <div className="search-input">
        <h5 className="form-title">User Access Management</h5>
        <Link to="/create-user-access-management" className="custom-btn">
          Create User
        </Link>
      </div>
      <div className="table-responsive">
        <table className="table table-striped vendor-info">
          <thead className="table-dark">
            <tr>
              <th>
                <label className="custom-checkbox">
                  <input
                    type="checkbox"
                    checked={allChecked}
                    onChange={handleSelectAll}
                  />
                  <span className="checkmark"></span>
                </label>
              </th>
              <th>User Name</th>
              <th>Role</th>
              <th>Email</th>
              <th>Phone Number</th>
              <th>Last Login</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={i}>
                <td>
                  <label className="custom-checkbox">
                    <input
                      type="checkbox"
                      checked={row.selected}
                      onChange={() => handleRowSelect(i)}
                    />
                    <span className="checkmark"></span>
                  </label>
                </td>
                <td>{row.user_name}</td>
                <td>{row.role}</td>
                <td>{row.email}</td>
                <td>{row.phone_number}</td>
                <td>{row.last_login}</td>
                <td>
                  <span className="action-link">
                    {row.action}
                    {row.img}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default UserAccessSection;
